import React from 'react'

import { SVGProps } from '../../types/svg'
import COLORS from '../../styles/colors'

const defaultSize = {
  width: 42,
  height: 38,
}

const WhatsApp = ({ style, color = COLORS.greyscale.white }: SVGProps) => (
  <svg
    id='WhatsApp'
    xmlns='http://www.w3.org/2000/svg'
    style={{ ...defaultSize, ...style }}
    viewBox='0 0 72.638 72.638'
  >
    <g id='Group_2' data-name='Group 2'>
      <path
        id='Path_3'
        data-name='Path 3'
        d='M36.328,0H36.31a36.3,36.3,0,0,0-29.4,57.607L2.388,71.1l13.96-4.463A36.313,36.313,0,1,0,36.328,0ZM57.461,51.287c-.876,2.474-4.354,4.526-7.128,5.126-1.9.4-4.376.726-12.721-2.733C26.94,49.258,20.066,38.412,19.531,37.708c-.513-.7-4.313-5.743-4.313-10.955a11.6,11.6,0,0,1,3.714-8.839,5.277,5.277,0,0,1,3.714-1.3c.449,0,.853.023,1.217.041,1.067.045,1.6.109,2.306,1.793.876,2.111,3.01,7.323,3.264,7.859a2.162,2.162,0,0,1,.154,1.966,6.276,6.276,0,0,1-1.176,1.666c-.536.617-1.044,1.09-1.58,1.752-.49.577-1.044,1.194-.427,2.261A32.237,32.237,0,0,0,32.3,41.272a26.7,26.7,0,0,0,8.517,5.253,2.3,2.3,0,0,0,2.56-.4,43.942,43.942,0,0,0,2.837-3.759,2.027,2.027,0,0,1,2.606-.79c.981.34,6.17,2.906,7.237,3.437s1.771.79,2.029,1.239S58.337,48.808,57.461,51.287Z'
        fill={color}
      />
    </g>
  </svg>
)

export default WhatsApp
